import { useEffect, useState } from 'react'

const isSelectKey = (event: KeyboardEvent) => event.ctrlKey || event.metaKey

// True while Ctrl (Cmd on a Mac) is down, the key that turns a drag into a box.
// Losing focus drops it, since the key-up would land in another window.
export const useSelectKeyHeld = () => {
  const [held, setHeld] = useState(false)

  useEffect(() => {
    const follow = (event: KeyboardEvent) => setHeld(isSelectKey(event))
    const release = () => setHeld(false)
    window.addEventListener('keydown', follow)
    window.addEventListener('keyup', follow)
    window.addEventListener('blur', release)
    return () => {
      window.removeEventListener('keydown', follow)
      window.removeEventListener('keyup', follow)
      window.removeEventListener('blur', release)
    }
  }, [])

  return held
}
